import ResultModel from "../../../Predictor/Models/Fixtures/ResultModel";

export default class PredictionTopXModel {
    public value: string = null;
    public result: ResultModel = null;
}